const settingsUrl = {
    fetchSettings: {
        url: '/settings'
    },
};

export default settingsUrl;
